// /** @format */

// import axios from "axios";

// const username = process.env.REACT_APP_USERNAME;
// const password = process.env.REACT_APP_PASSWORD;
// const credentials = `${username}:${password}`;
// const encodedCredentials = btoa(credentials);

// const instance = axios.create({
//   baseURL: process.env.REACT_APP_SERVER_URL,
//   // headers: {
//   //   Authorization: `Basic ${encodedCredentials}`,
//   // },
//   headers: {
//     "Content-Type": "application/json",
//     'Access-Control-Allow-Origin': '*',
//     'cache' : "nocache"

//   },
//   withCredentials : true
// });

// instance.interceptors.request.use(
//   function (config) {
//     // Chỉ gắn accessToken với các method POST, PUT, DELETE
//     // const accessToken = process.env.REACT_APP_ACCESS_TOKEN;
//     const accessToken = sessionStorage.getItem("accessToken"); // Lấy token từ sessionStorage
//     if (["POST", "PUT", "DELETE"].includes(config.method.toUpperCase())) {
//       config.headers["Authorization"] = `Bearer ${accessToken}`;
//     }
//     config.headers["Access-Control-Allow-Origin"] = "*";
//     return config;
//   },
//   function (err) {
//     return Promise.reject(err);
//   }
// );

// instance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (err) {
//     return Promise.reject(err);
//   }
// );

// export default instance;

/** @format */

import axios from "axios";

const username = process.env.REACT_APP_USERNAME;
const password = process.env.REACT_APP_PASSWORD;
const credentials = `${username}:${password}`;
const encodedCredentials = btoa(credentials);

const instance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  headers: {
    // "Cache-Control": "no-cache",
    // "Content-Type": "application",
    // "x-api-key": "48656c6c6f20576f726c6421",
  },
});

instance.interceptors.request.use(
  function (config) {
    const accessToken = sessionStorage.getItem("accessToken"); // Lấy token từ sessionStorage
    // if (["POST", "PUT", "DELETE"].includes(config.method.toUpperCase())) {
    //   config.headers["Authorization"] = `Bearer ${accessToken}`;
    // }
    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    return Promise.reject(err);
  }
);

export default instance;
